import { Component, inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserdataService } from '../../../../../service/userdata.service';
import { UserStreamResults } from '../../../../../interfaces/trackdata';
import { StepResult } from '../../../../../interfaces/responsedata.ts/trackresults';
import { KeyResultItemStatus } from './key-result-item/key-result-item.component';
import { Pin } from '../../pin/pin.component';
import { ResultPreviewComponent } from '../../result-preview/result-preview.component';
import { FeedbackPinsDashboardComponent } from '../feedback-pins-dashboard/feedback-pins-dashboard.component';
import { InternLandingPageComponent } from '../../../../../components-track/intern-landing-page/intern-landing-page.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-key-result-dashboard',
  standalone: false,
  templateUrl: './key-result-dashboard.component.html',
  styleUrl: './key-result-dashboard.component.scss'
})
export class KeyResultDashboardComponent implements AfterViewInit {
  // Injections
  dialogRef = inject(MatDialogRef<KeyResultDashboardComponent>);
  results = inject<any>(MAT_DIALOG_DATA).results;
  streams = inject<any>(MAT_DIALOG_DATA).streams;
  ship = inject<any>(MAT_DIALOG_DATA).ship;
  track = inject<any>(MAT_DIALOG_DATA).track;
  dialog = inject(MatDialog);
  userData = inject(UserdataService);
  router = inject(Router);

  // Qualify
  elevatorPitch: boolean | undefined;
  elevatorPitchStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  elevatorPitchData: any;
  mainPersona: boolean | undefined;
  mainPersonaStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  mainPersonaData: any;
  emapthyMap: boolean | undefined;
  emapthyMapStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  emapthyMapData: any;
  landingPage: boolean | undefined;
  landingPageStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;;

  // Validate
  marketReport: boolean | undefined;
  marketReportStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  marketReportData: any;
  competitorReport: boolean | undefined;
  competitorReportStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  competitorReportData: any;
  userValiReport: boolean | undefined;
  userValiReportStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  userValiReportData: any;
  mentorFeedbackReport: boolean | undefined;
  mentorFeedbackReportStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  mentorFeedbackReportData: any;

  // Ship
  bmc: boolean | undefined;
  bmcStatus: KeyResultItemStatus = KeyResultItemStatus.NOTAVAILABLE;
  bmcData: any;
  businessPlan: boolean | undefined;
  businessPlanStatus: KeyResultItemStatus = KeyResultItemStatus.COMINGSOON;
  goToMarketStrategy: boolean | undefined;
  goToMarketStrategyStatus: KeyResultItemStatus = KeyResultItemStatus.COMINGSOON;
  productRoadmap: boolean | undefined;
  productRoadmapStatus: KeyResultItemStatus = KeyResultItemStatus.COMINGSOON;

  // Objects
  qualifyStreamResults: StepResult[] | undefined;
  reportResults: StepResult[] | undefined;
  validateResults: StepResult[] | undefined;
  KeyResultItemStatus = KeyResultItemStatus;

  // Variables


  async ngAfterViewInit(): Promise<void> {
    // Qualify Stream Results
    if (!this.results) return;
    let qualifyStream = await this.results.find((result: UserStreamResults) => result.streamId === "J1S-8At2nL");
    this.qualifyStreamResults = qualifyStream?.stepResults;
    // Reports & Landing PageResults
    let reports = await this.results.find((result: UserStreamResults) => result.streamId === "export_reports");
    this.reportResults = reports?.stepResults;
    // Validate Stream PageResults
    let validates = await this.results.find((result: UserStreamResults) => result.streamId === "4dXLpB4Ll");
    this.validateResults = validates?.stepResults;


    // Get Persona from Results
    await this.getPersona();
    await this.empathyMap();

    if (this.mainPersona === true && this.emapthyMap === true) {
      this.landingPage = false;
      this.landingPageStatus = KeyResultItemStatus.INPROGRESS;
      this.landingPageExists();
    }

    this.checkElevatorPitch();
    this.checkReports();
  }
    async goto(streamId: string, stepId:string) {
    this.router.navigate(['new-track-run', this.track.trackData.id], {
      queryParams: {
        streamId,
        stepId,
        roundId: this.track.roundId
      }
    });
    this.dialog.closeAll();
  }

  async openLandingPage() {
    await this.dialog.open(InternLandingPageComponent, {
      panelClass: "feed-back-card",
      data: { projectId: this.track.roundId }
    });
  }
  async openFeedbackPinDashbord() {
    let feedbackCardResultObject = await this.validateResults?.find(r => r.stepId === "k9G9Fv8w6");
    let feedbackCardResult;
    if (feedbackCardResultObject) {
      feedbackCardResult = feedbackCardResultObject.result;
    }
    this.dialog.open(FeedbackPinsDashboardComponent, {
      panelClass: "feed-back-card",
      autoFocus: false,
      data: {
        "name": this.track.name,
        "feedbackCardResult": feedbackCardResult,
        "trackId": this.track.trackId,
        "roundId": this.track.roundId,
        "streamId": "4dXLpB4Ll",
        "results": this.track.results,
        "stepId": "k9G9Fv8w6"
      }
    });
  }
  async checkReports() {
    // Get all Pins from the validation results
    let pins;
    let pinsResult = await this.validateResults?.find(r => r.stepId === "k9G9Fv8w6")
    if (pinsResult) {
      pins = pinsResult.result?.['pins'] ?? [];
    }

    // Check Competition Report Status
    let competition = await this.reportResults?.find(r => r.stepId === "REPORT_COMPETITION");
    if (competition) {
      this.competitorReport = true;
      this.competitorReportStatus = KeyResultItemStatus.COMPLETED;
      this.competitorReportData = competition.result;
    } else {
      let compPins = await pins?.filter((p: Pin) => p.agentName === "Competition Expert");
      if (compPins?.length > 0) {
        this.competitorReport = false;
        this.competitorReportStatus = KeyResultItemStatus.INPROGRESS;
      }
    }
    // Check Market Expert Report Status
    let market = await this.reportResults?.find(r => r.stepId === "REPORT_MARKET");
    if (market) {
      this.marketReport = true;
      this.marketReportStatus = KeyResultItemStatus.COMPLETED;
      this.marketReportData = market.result;
    } else {
      let compPins = await pins?.filter((p: Pin) => p.agentName === "Market Expert");
      if (compPins?.length > 0) {
        this.marketReport = false;
        this.marketReportStatus = KeyResultItemStatus.INPROGRESS;
      }
    }
    // Check Synthetic User Report Status
    let vali = await this.reportResults?.find(r => r.stepId === "REPORT_USER_RESEARCH");
    if (vali) {
      this.userValiReport = true;
      this.userValiReportStatus = KeyResultItemStatus.COMPLETED;
      this.userValiReportData = vali.result;
    } else {
      let compPins = await pins?.filter((p: Pin) => p.agentName === "Synthetic User");
      if (compPins?.length > 0) {
        this.userValiReport = false;
        this.userValiReportStatus = KeyResultItemStatus.INPROGRESS;
      }
    }
    // Check Startup Mentor Report Status
    let startup = await this.reportResults?.find(r => r.stepId === "REPORT_MENTOR");
    if (startup) {
      this.mentorFeedbackReport = true;
      this.mentorFeedbackReportStatus = KeyResultItemStatus.COMPLETED;
      this.mentorFeedbackReportData = startup.result;
    } else {
      let compPins = await pins?.filter((p: Pin) => p.agentName === "Startup Mentor");
      if (compPins?.length > 0) {
        this.mentorFeedbackReport = false;
        this.mentorFeedbackReportStatus = KeyResultItemStatus.INPROGRESS;
      }
    }

    // Check BMC
    if (pins?.length > 0) {
      this.bmc = false;
      this.bmcStatus = KeyResultItemStatus.INPROGRESS;
    }
    let bmc = await this.reportResults?.find(r => r.stepId === "REPORT_BMC");
    if (bmc) {
      this.bmc = true;
      this.bmcStatus = KeyResultItemStatus.COMPLETED;
      this.bmcData = bmc.result;
    }
  }

  close() {
    this.dialogRef.close();
  }
  async switchActiveContent(event: any) {
    let activeContent = event.name;
    document.querySelector(`#${activeContent.toLowerCase()}`)?.scrollIntoView({ behavior: 'smooth' });
  }

  async checkElevatorPitch() {
    let basicIdea = await this.qualifyStreamResults?.find((result: StepResult) => result.stepId === "MMUT2vQla");
    let userTinder = await this.qualifyStreamResults?.find((result: StepResult) => result.stepId === "Ci6Ju_grd");
    let userInsightMap = await this.qualifyStreamResults?.find((result: StepResult) => result.stepId === "jKHo2wIzi");


    if (basicIdea && userTinder && userInsightMap) {
      this.elevatorPitch = false;
      this.elevatorPitchStatus = KeyResultItemStatus.INPROGRESS;
      let createdElevatorPitch = await this.reportResults?.find((result: StepResult) => result.stepId === "elevatorPitch");
      if (createdElevatorPitch) {
        this.elevatorPitch = true;
        this.elevatorPitchStatus = KeyResultItemStatus.COMPLETED;
      }
    }
  }

  async landingPageExists() {
    let lpResult = await this.reportResults?.find((stepResult) => stepResult.stepId === "landingPage");
    if (lpResult) {
      this.landingPage = true;
      this.landingPageStatus = KeyResultItemStatus.COMPLETED;
    }
    // console.log("empathyMapResult", lpResult);
  }
  async empathyMap() {
    let empathyMapResult = await this.qualifyStreamResults?.find((stepResult) => stepResult.stepId === "jKHo2wIzi");
    if (empathyMapResult) {
      this.emapthyMap = true;
      this.emapthyMapStatus = KeyResultItemStatus.COMPLETED;
      if(!empathyMapResult.result['name']){
        empathyMapResult.result['name'] = "User Insight Mapping";
      }
      this.emapthyMapData = empathyMapResult.result;
      console.log("Empathy Map Result:", this.emapthyMapData);

    } else {
      let persona = await this.qualifyStreamResults?.find((stepResult) => stepResult.stepId === "Ci6Ju_grd");
      if (persona) {
        this.emapthyMap = false;
        this.emapthyMapStatus = KeyResultItemStatus.INPROGRESS;
      }
    }
    // console.log("empathyMapResult", empathyMapResult);
  }
  async getPersona() {
    let persona = await this.qualifyStreamResults?.find((stepResult) => stepResult.stepId === "Ci6Ju_grd");
    if (persona) {
      this.mainPersona = true;
      this.mainPersonaStatus = KeyResultItemStatus.COMPLETED;
      this.mainPersonaData = persona.result;
    } else {
      let basicIdea = await this.qualifyStreamResults?.find((result: StepResult) => result.stepId === "MMUT2vQla");
      if (basicIdea) {
        this.mainPersona = false;
        this.mainPersonaStatus = KeyResultItemStatus.INPROGRESS;
      }
    }
    // console.log("persona", persona);
  }

  async openPdfPreview(data: any) {
    if (!data) {
      alert("No data available for preview.");
      return;
    }
    this.dialog.open(ResultPreviewComponent, {
      panelClass: "feed-back-card",
      autoFocus: false,
      data: data
    })
  }
}
